import { Component, OnInit, OnDestroy, Inject, Injectable } from '@angular/core';
import { Person } from 'src/app/people/models/person';
import { PersonDetailsService } from 'src/app/shared/services/person-details.service';
import { PersonStatus } from 'src/app/people/models/personStatus';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PersonWorkspace } from '../../models/workspace/personWorkspace';

@Component({
  selector: 'person-workspace-status-edit-modal',
  templateUrl: 'person-workspace-status-edit-modal.component.html',
  styleUrls: ['person-workspace-status-edit-modal.component.scss'],
  standalone: false
})
@Injectable()
export class PersonWorkspaceStatusEditModalComponent implements OnInit {
  person: Person;
  personStatus: string;
  workspace: PersonWorkspace;

  constructor(
    private personDetailsService: PersonDetailsService,
    public dialogRef: MatDialogRef<PersonWorkspaceStatusEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.person = this.data.person;
    this.workspace = this.data.workspace;
    this.personStatus = this.workspace.personWorkspaceStatus;
  }

  statusChanged() {
    return (
      this.person && this.workspace && this.personStatus != this.workspace.personWorkspaceStatus
    );
  }

  setArchived() {
    this.personStatus = PersonStatus.Archived;
  }

  setActive() {
    this.personStatus = PersonStatus.Active;
  }

  setPotential() {
    if (this.workspace.numOfPersonWorkspaceTeams === 0) {
      this.personStatus = PersonStatus.Potential;
    }
  }

  save() {
    this.personDetailsService
      .setStatus(this.person.id, this.personStatus, this.workspace.workspaceId)
      .subscribe(() => {
        this.dialogRef.close(true);
      });
  }

  close() {
    this.dialogRef.close();
  }
}
